<!-- 导入题目 -->
<template>
  <div class="el-ErrorSet">
    <el-row class="content_block">
      <TitleInfo title="批量导入试题" :titleImg="zjie"></TitleInfo>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <el-row class="mb20">
          <label>批量导入模板下载：</label>
          <el-button type="primary" @click="exportBatchTemplate" icon="el-icon-download">下载模板</el-button>
        </el-row>
        <el-row class="mb20">
          <label style="float: left;">上传批量导入文件：</label>
          <el-row style="margin-left: 144px;width: 800px;">
            <el-upload
              class="upload-demo"
              drag
              :action="action"
              :headers="headers"
              :on-success="handleSuccess"
              multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>
          </el-row>
        </el-row>
        <el-row class="mb20">
          <p>批量导入错误列表：</p>
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column type="index" header-align="center" align="center" width="80" label="序号"></el-table-column>
            <el-table-column prop="failMessage" header-align="left" align="left" label="错误原因"> </el-table-column>
            <el-table-column prop="type" header-align="center" align="center" label="操作" width="200">
              <template slot-scope="scope">
                <!-- <el-link type="danger" :underline="false">删除</el-link> -->
              </template>
            </el-table-column>
          </el-table>
          <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              background
              :hide-on-single-page="true"
              layout="sizes, prev, pager, next,jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-row>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo"; //页面头部
export default {
  name: "ErrorSet",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      headers: {
        token: this.$getToken()
      },
      zjie:require("../../images/course/zjie@2x.png"),
      action: this.$baseUrl + '/api/teacherOpenCourseMergeResourcesQuestion/importBatchTemplate.do',
      tableData:[],

      total: 0,
      limit:10,
      page:1,
    };
  },
  created() {

  },
  mounted() {
    this.getInfo();
  },
  methods: {
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page = val;
        this.getInfo();
    },
    handleSizeChange_stu(val) {
        console.log(`每页 ${val} 条`);
    },
    handleCurrentChange_stu(val) {
        console.log(`当前页: ${val}`);
        this.page_stu = val_stu;
        this.getInfo();
    },
    getInfo(){ //获取通知公告列表
      // this.$store.dispatch("user/getNoticeList",{limit:this.limit,page:this.page})
      // .then((ret) => {
      //   if(ret.code == 0){
      //     this.noticeList = ret.data;
      //     this.total = ret.count;
      //   }else{
      //     this.$message({
      //        message: ret.msg,
      //        type: "warning"
      //     });
      //   }
      // });
    },
    // 上传成功后的回调
    handleSuccess(res, file) {
      // this.tableData = [];
      if(res.code == 0){
        this.$message.success("导入成功！");
      }else{
        this.$message.error(res.msg);
      }
      this.tableData = res.data;
    },
    exportBatchTemplate(){ //导出信息
      this.$downLoadFile(this.$baseUrl + "/api/teacherOpenCourseMergeResourcesQuestion/exportBatchTemplate.do",'批量题库导入模板.xlsx');
      //window.open(this.$baseUrl + "/api/teacherOpenCourseMergeResourcesQuestion/exportBatchTemplate.do");
    },
  }
};
</script>
 <style  lang="less">
  .el-ErrorSet{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/ExportQuestion.vue